"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const getErrorMessageNoAppIdFoundInApp_1 = __importDefault(require("../getErrorMessageNoAppIdFoundInApp"));
const getErrorMessageNoProjectIdFoundInApp_1 = __importDefault(require("../getErrorMessageNoProjectIdFoundInApp"));
const callableForgetPassword = async ({ functionId, entryVars: { email }, callbacks, executeProcesses, processor, }) => {
    const onError = (errorData) => {
        executeProcesses(functionId, callbacks.errorProcess, errorData);
    };
    if (!(0, valueIsString_1.default)(email)) {
        onError('Email is invalid');
        return;
    }
    if (!processor.root.isInDevelopment) {
        await processor.root.firebase.auth().sendPasswordResetEmail(email)
            .then(() => {
            executeProcesses(undefined, callbacks.successProcess);
        }).catch((error) => {
            if (error.code === 'auth/user-not-found') {
                executeProcesses(functionId, callbacks.noEmailFound, `User with email ${email} not found`);
            }
            else {
                onError(error.message);
            }
        });
        return;
    }
    const CALLER_NAME = 'forgetPassword';
    const projectId = processor.root.getProjectId();
    if (!projectId) {
        onError((0, getErrorMessageNoProjectIdFoundInApp_1.default)(CALLER_NAME));
        return;
    }
    const appId = processor.root.getAppId();
    if (!appId) {
        onError((0, getErrorMessageNoAppIdFoundInApp_1.default)(CALLER_NAME));
        return;
    }
    processor.root.cloud.renderForgetPassword({
        projectId,
        appId,
        email,
    }).then(({ success }) => {
        if (success) {
            executeProcesses(undefined, callbacks.successProcess);
            return;
        }
        throw new Error('Something went wrong');
    }).catch((error) => {
        onError(error);
    });
};
exports.default = callableForgetPassword;
